export default __webpack_public_path__ + "static/airline-587f29d1e1db4eb359819c95b3dc51da.jpg";